import { useState, useCallback } from 'react';

export function useSelectedShape(initialShapes = []) {
  const [shapes, setShapes] = useState(initialShapes);
  const [selectedId, setSelectedId] = useState(null);

  const selectedShape = shapes.find(s => s.id === selectedId);

  const handleShapeChange = useCallback((updatedShape) => {
    setShapes(prevShapes => 
      prevShapes.map(shape => 
        shape.id === updatedShape.id ? updatedShape : shape
      )
    );
  }, []);

  const addShape = useCallback((newShape) => {
    setShapes(prevShapes => [...prevShapes, newShape]);
    setSelectedId(newShape.id);
  }, []);

  const removeShape = useCallback((id) => {
    setShapes(prevShapes => prevShapes.filter(shape => shape.id !== id));
    if (selectedId === id) {
      setSelectedId(null);
    }
  }, [selectedId]);

  const moveShapeUp = useCallback((id) => {
    setShapes(prevShapes => {
      const index = prevShapes.findIndex(shape => shape.id === id);
      if (index < prevShapes.length - 1) {
        const newShapes = [...prevShapes];
        [newShapes[index], newShapes[index + 1]] = [newShapes[index + 1], newShapes[index]];
        return newShapes;
      }
      return prevShapes;
    });
  }, []);

  const moveShapeDown = useCallback((id) => {
    setShapes(prevShapes => {
      const index = prevShapes.findIndex(shape => shape.id === id);
      if (index > 0) {
        const newShapes = [...prevShapes];
        [newShapes[index - 1], newShapes[index]] = [newShapes[index], newShapes[index - 1]];
        return newShapes;
      }
      return prevShapes;
    });
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedId(null);
  }, []);

  return {
    shapes,
    setShapes,
    selectedId,
    setSelectedId,
    selectedShape,
    handleShapeChange,
    addShape,
    removeShape,
    moveShapeUp,
    moveShapeDown,
    clearSelection
  };
}